// routes/index.js

import React, { useContext, useEffect } from "react";
import {  Route, Routes, Navigate } from "react-router-dom";
import HelmetWrapper from './HelmetWrapper';


import Home from "../pages/Home";
import Login from "../pages/Auth/Login";
import ShopDashboard from "../pages/Shop/Dashboard";
import ShopPurchaseList from "../pages/Shop/Purchase/List";
import ShopPurchaseAdd from "../pages/Shop/Purchase/AddPurchase";
import ShopPurchaseEdit from "../pages/Shop/Purchase/EditPurchase";
import ShopSellList from "../pages/Shop/Sell/List";
import ShopSellAdd from "../pages/Shop/Sell/AddSell";
import ShopSellEdit from "../pages/Shop/Sell/EditSell";
import ShopDairyProductList from "../pages/Shop/DairyProduct/List";
import ShopDairyProductAdd from "../pages/Shop/DairyProduct/AddDairyProduct";
import ShopDairyProductEdit from "../pages/Shop/DairyProduct/EditDairyProduct";
import ShopFixCostList from "../pages/Shop/FixCost/List";
import ShopFixCostAdd from "../pages/Shop/FixCost/AddFixCost";
import ShopFixCostEdit from "../pages/Shop/FixCost/EditFixCost";
import ShopStaffList from "../pages/Shop/Staff/List";
import ShopStaffAdd from "../pages/Shop/Staff/AddStaff";
import ShopStaffEdit from "../pages/Shop/Staff/EditStaff";
import ShopSalaryList from "../pages/Shop/Salary/List";
import ShopSalaryAdd from "../pages/Shop/Salary/AddSalary";
import ShopSalaryEdit from "../pages/Shop/Salary/EditSalary";
import ShopProductList from "../pages/Shop/Product/List";
import ShopProductAdd from "../pages/Shop/Product/AddProduct";
import ShopProductEdit from "../pages/Shop/Product/EditProduct";

import AdminDashboard from "../pages/Admin/Dashboard";
import ProfileLabourList from "../pages/Admin/Profile/Labour/List";
import ProfileLabourAdd from "../pages/Admin/Profile/Labour/AddLabour";
import ProfileLabourEdit from "../pages/Admin/Profile/Labour/EditLabour";
import ProfileAnimalList from "../pages/Admin/Profile/Animal/List";
import ProfileAnimalAdd from "../pages/Admin/Profile/Animal/AddAnimal";
import ProfileAnimalEdit from "../pages/Admin/Profile/Animal/EditAnimal";
import ProfileCompanyList from "../pages/Admin/Profile/Company/List";
import ProfileCompanyAdd from "../pages/Admin/Profile/Company/AddCompany";
import ProfileCompanyEdit from "../pages/Admin/Profile/Company/EditCompany";
import ProfileProductList from "../pages/Admin/Profile/Product/List";
import ProfileProductAdd from "../pages/Admin/Profile/Product/AddProduct";
import ProfileProductEdit from "../pages/Admin/Profile/Product/EditProduct";

import FarmDashboard from "../pages/Admin/Farm/Dashboard";
import FarmLabourList from "../pages/Admin/Farm/Labour/List";
import FarmLabourAdd from "../pages/Admin/Farm/Labour/AddLabour";
import FarmLabourEdit from "../pages/Admin/Farm/Labour/EditLabour";
import FarmFuelList from "../pages/Admin/Farm/Fuel/List";
import FarmFuelAdd from "../pages/Admin/Farm/Fuel/AddFuel";
import FarmFuelEdit from "../pages/Admin/Farm/Fuel/EditFuel";
import FarmMedicalList from "../pages/Admin/Farm/Medical/List";
import FarmMedicalAdd from "../pages/Admin/Farm/Medical/AddMedical";
import FarmMedicalEdit from "../pages/Admin/Farm/Medical/EditMedical";
import FarmFeedList from "../pages/Admin/Farm/Feed/List";
import FarmFeedAdd from "../pages/Admin/Farm/Feed/AddFeed";
import FarmFeedEdit from "../pages/Admin/Farm/Feed/EditFeed";
import FarmAnimalBuySellList from "../pages/Admin/Farm/Animal/BuySell/List";
import FarmAnimalBuySellAdd from "../pages/Admin/Farm/Animal/BuySell/AddBuySell";
import FarmAnimalBuySellEdit from "../pages/Admin/Farm/Animal/BuySell/EditBuySell";
import FarmAnimalHealthList from "../pages/Admin/Farm/Animal/Health/List";
import FarmAnimalHealthAdd from "../pages/Admin/Farm/Animal/Health/AddHealth";
import FarmAnimalHealthEdit from "../pages/Admin/Farm/Animal/Health/EditHealth";
import FarmMilkProductionList from "../pages/Admin/Farm/Milk/Production/List";
import FarmMilkProductionAdd from "../pages/Admin/Farm/Milk/Production/AddProduction";
import FarmMilkProductionEdit from "../pages/Admin/Farm/Milk/Production/EditProduction";
import FarmMilkDistributorList from "../pages/Admin/Farm/Milk/Distributor/List";
import FarmMilkDistributorAdd from "../pages/Admin/Farm/Milk/Distributor/AddDistributor";
import FarmMilkDistributorEdit from "../pages/Admin/Farm/Milk/Distributor/EditDistributor";
import FarmOtherList from "../pages/Admin/Farm/Other/List";
import FarmOtherAdd from "../pages/Admin/Farm/Other/AddOther";
import FarmOtherEdit from "../pages/Admin/Farm/Other/EditOther";

import ConstructionDashboard from "../pages/Admin/Construction/Dashboard";
import ConstructionLabourList from "../pages/Admin/Construction/Labour/List";
import ConstructionLabourAdd from "../pages/Admin/Construction/Labour/AddLabour";
import ConstructionLabourEdit from "../pages/Admin/Construction/Labour/EditLabour";
import ConstructionContractorList from "../pages/Admin/Construction/Contractor/List";
import ConstructionContractorAdd from "../pages/Admin/Construction/Contractor/AddContractor";
import ConstructionContractorEdit from "../pages/Admin/Construction/Contractor/EditContractor";
import ConstructionOtherList from "../pages/Admin/Construction/Other/List";
import ConstructionOtherAdd from "../pages/Admin/Construction/Other/AddOther";
import ConstructionOtherEdit from "../pages/Admin/Construction/Other/EditOther";

import AgricultureDashboard from "../pages/Admin/Agriculture/Dashboard";
import AgricultureLabourList from "../pages/Admin/Agriculture/Labour/List";
import AgricultureLabourAdd from "../pages/Admin/Agriculture/Labour/AddLabour";
import AgricultureLabourEdit from "../pages/Admin/Agriculture/Labour/EditLabour";
import AgricultureFeedList from "../pages/Admin/Agriculture/Feed/List";
import AgricultureFeedAdd from "../pages/Admin/Agriculture/Feed/AddFeed";
import AgricultureFeedEdit from "../pages/Admin/Agriculture/Feed/EditFeed";
import AgricultureFuelList from "../pages/Admin/Agriculture/Fuel/List";
import AgricultureFuelAdd from "../pages/Admin/Agriculture/Fuel/AddFuel";
import AgricultureFuelEdit from "../pages/Admin/Agriculture/Fuel/EditFuel";
import AgricultureOtherList from "../pages/Admin/Agriculture/Other/List";
import AgricultureOtherAdd from "../pages/Admin/Agriculture/Other/AddOther";
import AgricultureOtherEdit from "../pages/Admin/Agriculture/Other/EditOther";
import AgricultureSellList from "../pages/Admin/Agriculture/Sell/List";
import AgricultureSellAdd from "../pages/Admin/Agriculture/Sell/AddSell";
import AgricultureSellEdit from "../pages/Admin/Agriculture/Sell/EditSell";

import AccountList from "../pages/Admin/Account/List";
import AccountAdd from "../pages/Admin/Account/AddAccount";
import AccountEdit from "../pages/Admin/Account/EditAccount";

function AppRouter() {

  const routes = [
    
    { path: "/login", component: Login, title: "Login",  allowedRoles:[1]  },
    { path: "/shop_dashboard", component: ShopDashboard, title: "Shop Dashboard",  allowedRoles:[1]  },
    { path: "/shop_purchase/list", component: ShopPurchaseList, title: "Shop Purchase List",  allowedRoles:[1]  },
    { path: "/shop_purchase/add", component: ShopPurchaseAdd, title: "Shop Purchase Add",  allowedRoles:[1]  },
    { path: "/shop_purchase/edit/:id", component: ShopPurchaseEdit, title: "Shop Purchase Edit",  allowedRoles:[1]  },
    { path: "/shop_sell/list", component: ShopSellList, title: "Shop Sell List",  allowedRoles:[1]  },
    { path: "/shop_sell/add", component: ShopSellAdd, title: "Shop Sell Add",  allowedRoles:[1]  },
    { path: "/shop_sell/edit/:id", component: ShopSellEdit, title: "Shop Sell Edit",  allowedRoles:[1]  },
    { path: "/shop_dairy_product/list", component: ShopDairyProductList, title: "Shop Dairy Product List",  allowedRoles:[1]  },
    { path: "/shop_dairy_product/add", component: ShopDairyProductAdd, title: "Shop Dairy Product Add",  allowedRoles:[1]  },
    { path: "/shop_dairy_product/edit/:id", component: ShopDairyProductEdit, title: "Shop Dairy Product Edit",  allowedRoles:[1]  },
    { path: "/shop_fix_cost/list", component: ShopFixCostList, title: "Shop Fix Cost List",  allowedRoles:[1]  },
    { path: "/shop_fix_cost/add", component: ShopFixCostAdd, title: "Shop Fix Cost Add",  allowedRoles:[1]  },
    { path: "/shop_fix_cost/edit/:id", component: ShopFixCostEdit, title: "Shop Fix Cost Edit",  allowedRoles:[1]  },
    { path: "/shop_staff/list", component: ShopStaffList, title: "Shop Staff List",  allowedRoles:[1]  },
    { path: "/shop_staff/add", component: ShopStaffAdd, title: "Shop Staff Add",  allowedRoles:[1]  },
    { path: "/shop_staff/edit/:id", component: ShopStaffEdit, title: "Shop Staff Edit",  allowedRoles:[1]  },
    { path: "/shop_salary/list", component: ShopSalaryList, title: "Shop Salary List",  allowedRoles:[1]  },
    { path: "/shop_salary/add", component: ShopSalaryAdd, title: "Shop Salary Add",  allowedRoles:[1]  },
    { path: "/shop_salary/edit/:id", component: ShopSalaryEdit, title: "Shop Salary Edit",  allowedRoles:[1]  },
    { path: "/shop_product/list", component: ShopProductList, title: "Shop Product List",  allowedRoles:[1]  },
    { path: "/shop_product/add", component: ShopProductAdd, title: "Shop Product Add",  allowedRoles:[1]  },
    { path: "/shop_product/edit/:id", component: ShopProductEdit, title: "Shop Product Edit",  allowedRoles:[1]  },

    { path: "/admin/dashboard", component: AdminDashboard, title: "Dashboard",  allowedRoles:[2]  },
    { path: "/admin/profile/labour", component: ProfileLabourList, title: "Labour List",  allowedRoles:[2] },
    { path: "/admin/profile/labour/add", component: ProfileLabourAdd, title: "Labour Add",  allowedRoles:[2]  },
    { path: "/admin/profile/labour/edit/:id", component: ProfileLabourEdit, title: "Labour Edit",  allowedRoles:[2]  },
    { path: "/admin/profile/animal", component: ProfileAnimalList, title: "Animal List",  allowedRoles:[2] },
    { path: "/admin/profile/animal/add", component: ProfileAnimalAdd, title: "Animal Add",  allowedRoles:[2]  },
    { path: "/admin/profile/animal/edit/:id", component: ProfileAnimalEdit, title: "Animal Edit",  allowedRoles:[2]  },
    { path: "/admin/profile/company", component: ProfileCompanyList, title: "Company List",  allowedRoles:[2] },
    { path: "/admin/profile/company/add", component: ProfileCompanyAdd, title: "Company Add",  allowedRoles:[2]  },
    { path: "/admin/profile/company/edit/:id", component: ProfileCompanyEdit, title: "Company Edit",  allowedRoles:[2]  },
    { path: "/admin/profile/product", component: ProfileProductList, title: "Product List",  allowedRoles:[2] },
    { path: "/admin/profile/product/add", component: ProfileProductAdd, title: "Product Add",  allowedRoles:[2]  },
    { path: "/admin/profile/product/edit/:id", component: ProfileProductEdit, title: "Product Edit",  allowedRoles:[2]  },

    { path: "/admin/farm/dashboard", component: FarmDashboard, title: "Farm Dashboard",  allowedRoles:[2]  },
    { path: "/admin/farm/labour", component: FarmLabourList, title: "Farm Labour",  allowedRoles:[2]  },
    { path: "/admin/farm/labour/add", component: FarmLabourAdd, title: "Farm Labour Add",  allowedRoles:[2]  },
    { path: "/admin/farm/labour/edit/:id", component: FarmLabourEdit, title: "Farm Labour Edit",  allowedRoles:[2]  },
    { path: "/admin/farm/fuel", component: FarmFuelList, title: "Farm Fuel",  allowedRoles:[2]  },
    { path: "/admin/farm/fuel/add", component: FarmFuelAdd, title: "Farm Fuel Add",  allowedRoles:[2]  },
    { path: "/admin/farm/fuel/edit/:id", component: FarmFuelEdit, title: "Farm Fuel Edit",  allowedRoles:[2]  },
    { path: "/admin/farm/medical", component: FarmMedicalList, title: "Farm Medical",  allowedRoles:[2]  },
    { path: "/admin/farm/medical/add", component: FarmMedicalAdd, title: "Farm Medical Add",  allowedRoles:[2]  },
    { path: "/admin/farm/medical/edit/:id", component: FarmMedicalEdit, title: "Farm Medical Edit",  allowedRoles:[2]  },
    { path: "/admin/farm/feed", component: FarmFeedList, title: "Farm Feed",  allowedRoles:[2]  },
    { path: "/admin/farm/feed/add", component: FarmFeedAdd, title: "Farm Feed Add",  allowedRoles:[2]  },
    { path: "/admin/farm/feed/edit/:id", component: FarmFeedEdit, title: "Farm Feed Edit",  allowedRoles:[2]  },
    { path: "/admin/farm/animal/buy_sell", component: FarmAnimalBuySellList, title: "Farm Animal Buy Sell",  allowedRoles:[2]  },
    { path: "/admin/farm/animal/buy_sell/add", component: FarmAnimalBuySellAdd, title: "Farm Animal Buy Sell Add",  allowedRoles:[2]  },
    { path: "/admin/farm/animal/buy_sell/edit/:id", component: FarmAnimalBuySellEdit, title: "Farm Animal Buy Sell Edit",  allowedRoles:[2]  },
    { path: "/admin/farm/animal/health", component: FarmAnimalHealthList, title: "Farm Animal Health",  allowedRoles:[2]  },
    { path: "/admin/farm/animal/health/add", component: FarmAnimalHealthAdd, title: "Farm Animal Health Add",  allowedRoles:[2]  },
    { path: "/admin/farm/animal/health/edit/:id", component: FarmAnimalHealthEdit, title: "Farm Animal Health Edit",  allowedRoles:[2]  },
    { path: "/admin/farm/milk/production", component: FarmMilkProductionList, title: "Farm Milk Production",  allowedRoles:[2]  },
    { path: "/admin/farm/milk/production/add", component: FarmMilkProductionAdd, title: "Farm Milk Production Add",  allowedRoles:[2]  },
    { path: "/admin/farm/milk/production/edit/:id", component: FarmMilkProductionEdit, title: "Farm Milk Production Edit",  allowedRoles:[2]  },
    { path: "/admin/farm/milk/distributor", component: FarmMilkDistributorList, title: "Farm Milk Distributor",  allowedRoles:[2]  },
    { path: "/admin/farm/milk/distributor/add", component: FarmMilkDistributorAdd, title: "Farm Milk Distributor Add",  allowedRoles:[2]  },
    { path: "/admin/farm/milk/distributor/edit/:id", component: FarmMilkDistributorEdit, title: "Farm Milk Distributor Edit",  allowedRoles:[2]  },
    { path: "/admin/farm/other", component: FarmOtherList, title: "Farm Other",  allowedRoles:[2]  },
    { path: "/admin/farm/other/add", component: FarmOtherAdd, title: "Farm Other Add",  allowedRoles:[2]  },
    { path: "/admin/farm/other/edit/:id", component: FarmOtherEdit, title: "Farm Other Edit",  allowedRoles:[2]  },

    { path: "/admin/construction/dashboard", component: ConstructionDashboard, title: "Construction Dashboard",  allowedRoles:[2]  },
    { path: "/admin/construction/labour", component: ConstructionLabourList, title: "Construction Labour",  allowedRoles:[2]  },
    { path: "/admin/construction/labour/add", component: ConstructionLabourAdd, title: "Construction Labour Add",  allowedRoles:[2]  },
    { path: "/admin/construction/labour/edit/:id", component: ConstructionLabourEdit, title: "Construction Labour Edit",  allowedRoles:[2]  },
    { path: "/admin/construction/contractor", component: ConstructionContractorList, title: "Construction Contractor",  allowedRoles:[2]  },
    { path: "/admin/construction/contractor/add", component: ConstructionContractorAdd, title: "Construction Contractor Add",  allowedRoles:[2]  },
    { path: "/admin/construction/contractor/edit/:id", component: ConstructionContractorEdit, title: "Construction Contractor Edit",  allowedRoles:[2]  },
    { path: "/admin/construction/other", component: ConstructionOtherList, title: "Construction Other",  allowedRoles:[2]  },
    { path: "/admin/construction/other/add", component: ConstructionOtherAdd, title: "Construction Other Add",  allowedRoles:[2]  },
    { path: "/admin/construction/other/edit/:id", component: ConstructionOtherEdit, title: "Construction Other Edit",  allowedRoles:[2]  },

    { path: "/admin/agriculture/dashboard", component: AgricultureDashboard, title: "Agriculture Dashboard",  allowedRoles:[2]  },
    { path: "/admin/agriculture/labour", component: AgricultureLabourList, title: "Agriculture Labour",  allowedRoles:[2]  },
    { path: "/admin/agriculture/labour/add", component: AgricultureLabourAdd, title: "Agriculture Labour Add",  allowedRoles:[2]  },
    { path: "/admin/agriculture/labour/edit/:id", component: AgricultureLabourEdit, title: "Agriculture Labour Edit",  allowedRoles:[2]  },
    { path: "/admin/agriculture/feed", component: AgricultureFeedList, title: "Agriculture Feed",  allowedRoles:[2]  },
    { path: "/admin/agriculture/feed/add", component: AgricultureFeedAdd, title: "Agriculture Feed Add",  allowedRoles:[2]  },
    { path: "/admin/agriculture/feed/edit/:id", component: AgricultureFeedEdit, title: "Agriculture Feed Edit",  allowedRoles:[2]  },
    { path: "/admin/agriculture/fuel", component: AgricultureFuelList, title: "Agriculture Fuel",  allowedRoles:[2]  },
    { path: "/admin/agriculture/fuel/add", component: AgricultureFuelAdd, title: "Agriculture Fuel Add",  allowedRoles:[2]  },
    { path: "/admin/agriculture/fuel/edit/:id", component: AgricultureFuelEdit, title: "Agriculture Fuel Edit",  allowedRoles:[2]  },
    { path: "/admin/agriculture/other", component: AgricultureOtherList, title: "Agriculture Other",  allowedRoles:[2]  },
    { path: "/admin/agriculture/other/add", component: AgricultureOtherAdd, title: "Agriculture Other Add",  allowedRoles:[2]  },
    { path: "/admin/agriculture/other/edit/:id", component: AgricultureOtherEdit, title: "Agriculture Other Edit",  allowedRoles:[2]  },
    { path: "/admin/agriculture/sell", component: AgricultureSellList, title: "Agriculture Sell",  allowedRoles:[2]  },
    { path: "/admin/agriculture/sell/add", component: AgricultureSellAdd, title: "Agriculture Sell Add",  allowedRoles:[2]  },
    { path: "/admin/agriculture/sell/edit/:id", component: AgricultureSellEdit, title: "Agriculture Sell Edit",  allowedRoles:[2]  },

    { path: "/admin/account/list", component: AccountList, title: "Account List",  allowedRoles:[2]  },
    { path: "/admin/account/add", component: AccountAdd, title: "Account Add",  allowedRoles:[2]  },
    { path: "/admin/account/edit/:id", component: AccountEdit, title: "Account Edit",  allowedRoles:[2]  },
  ];
  
  return (
    <Routes>
       <Route path="/" element={<Navigate to="/login" replace />} />
      {routes.length > 0 && routes.map((route, index) => (
  
        <Route
          key={index}
          path={route.path}
          
          element={
            <HelmetWrapper title={route.title} route={route}>
              <route.component />
            </HelmetWrapper>
          }
        />
      
      ))}
      
    </Routes>
  );
}

export default AppRouter;
